import { supabase } from "@/integrations/supabase/client";
import { hasConsent } from "@/lib/consent";
import { getAttribution } from "@/lib/attribution";

let started = false;
let pending = false;
export async function reportOrganicVisit(): Promise<void> {
  if (pending || !hasConsent("analytics") || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true) return;
  try {
    const raw = sessionStorage.getItem("os_organic_touch");
    if (!raw || sessionStorage.getItem("os_organic_reported")) return;
    const touch = JSON.parse(raw);
    if (!["organic_search", "ai_assistant"].includes(touch.channel)) return;
    let id = sessionStorage.getItem("os_organic_session");
    if (!id) { id = crypto.randomUUID(); sessionStorage.setItem("os_organic_session", id); }
    pending = true;
    const { error } = await supabase.functions.invoke("record-organic-visit", { body: { session_id: id, analytics_consent: true, source: touch.source?.replace(/[^a-zA-Z0-9._-]/g, "").slice(0,100) || null, referrer_host: touch.referrer_host, landing_path: (touch.landing_path || "/").split("?")[0].slice(0, 200) } });
    if (!error) sessionStorage.setItem("os_organic_reported", "1");
  } catch { /* Reporting never blocks browsing. */ }
  finally { pending = false; }
}
export function initOrganicReporting(): void {
  if (started || typeof window === "undefined") return;
  started = true;
  try {
    const touch = getAttribution()?.last;
    // Only a touch captured on this page load qualifies, never yesterday's source.
    if (touch && Date.now() - Date.parse(touch.at) < 5000) {
      if (["organic_search", "ai_assistant"].includes(touch.channel)) sessionStorage.setItem("os_organic_touch", JSON.stringify(touch));
      else sessionStorage.removeItem("os_organic_touch");
    }
  } catch { /* Storage may be unavailable. */ }
  void reportOrganicVisit();
  window.addEventListener("os:consent-changed", () => void reportOrganicVisit());
  window.addEventListener("online", () => void reportOrganicVisit());
}